module.exports = __webpack_public_path__ + "img/gray.b37fb0c6.png";